import { ListingsListDelegate } from '../../../services/DataDelegate/ListingsDelegate/listings.list.delegate';

export namespace ListingsStates {
    export function listingsStatesFactory() {
        const listings = {
            list: { timestamp: new Date(), data: [], total: 100, currentPage: 1 },
            isFetching: false
        };
        return listings;
    }

    export function mutations() {
        return {
            updateListings(state: any) {
                const delegate = new ListingsListDelegate();
                const data: any = delegate.Data;
                state.listings.list.data = data;
                state.listings.list.currentPage = delegate.CurrentPage;
                state.listings.list.total = delegate.TotalItems;
                state.listings.list.timestamp = new Date();
            },
            listingStartFetching(state: any) {
                state.listings.isFetching = true;
            },
            listingEndFetching(state: any) {
                state.listings.isFetching = false;
            },
        };
    }
}
